import React, { useState } from 'react';
import { Wind, TreePine, GraduationCap, HeartPulse, Home, Scale, ChevronRight, Download } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { policiesData } from '../data/mock';

const iconMap = {
  Wind,
  TreePine,
  GraduationCap,
  HeartPulse,
  Home,
  Scale
};

export const Policies = () => {
  const [selectedPolicy, setSelectedPolicy] = useState(null);

  return (
    <section id="policies" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Download Programma Button */}
        <div className="flex justify-center mb-10">
          <a
            href="/docs/programma.pdf"
            download="Programma_Io_Cambio_Insieme.pdf"
            data-testid="download-programma-btn"
          >
            <Button
              size="lg"
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-6 text-lg group shadow-lg"
            >
              <Download className="mr-2 w-5 h-5 group-hover:-translate-y-0.5 transition-transform" />
              Scarica il Programma Elettorale
            </Button>
          </a>
        </div>

        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {policiesData.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {policiesData.subtitle}
          </p>
        </div>

        {/* Policies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {policiesData.policies.map((policy) => {
            const Icon = iconMap[policy.icon];
            const isSelected = selectedPolicy === policy.id;
            
            return (
              <Card
                key={policy.id}
                className={`group cursor-pointer overflow-hidden border-2 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 ${
                  isSelected 
                    ? 'border-cyan-500 shadow-2xl' 
                    : 'border-gray-100 hover:border-cyan-300'
                }`}
                onClick={() => setSelectedPolicy(isSelected ? null : policy.id)}
              >
                {/* Image */}
                <div className="relative h-56 overflow-hidden bg-gray-100">
                  <img
                    src={policy.image}
                    alt={policy.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-cyan-600 transition-colors">
                    {policy.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {policy.description}
                  </p>

                  {/* Details - Expandable */}
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isSelected ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="pt-4 border-t border-gray-200 mt-4 space-y-2">
                      {policy.details.map((detail) => (
                        <div key={detail} className="flex items-start gap-2">
                          <ChevronRight className="w-5 h-5 text-cyan-500 flex-shrink-0 mt-0.5" />
                          <span className="text-sm text-gray-700">{detail}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <Button
                    variant="ghost"
                    className="w-full mt-4 text-cyan-600 hover:text-cyan-700 hover:bg-cyan-50"
                  >
                    {isSelected ? 'Chiudi dettagli' : 'Scopri di più'}
                    <ChevronRight className={`ml-2 w-4 h-4 transition-transform ${isSelected ? 'rotate-90' : ''}`} />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
